import React from 'react';
import { Typography, Row, Col, Card as AntCard } from 'antd';
import { CloudSun, Leaf } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import SimpleDashboardLayout from '../components/layout/SimpleDashboardLayout';
import { useLanguage } from '../context/LanguageContext';

// Type workaround for Card component - antd type issue
const Card = AntCard as any;

const { Title, Text } = Typography;

export const SimpleDashboard: React.FC = () => {
  const { user } = useAuthStore();
  const { t } = useLanguage();

  return (
    <SimpleDashboardLayout>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        <div className="text-center mb-8">
          <Title level={4} className="mb-2">{t('welcome')}, {user?.name || 'Farmer'}!</Title>
          <Text className="text-gray-500">{t('select_service')}</Text>
        </div>

        <Row gutter={[16, 16]} className="mt-6">
          <Col xs={24} sm={12}>
            <Link to="/dashboard/weather-station">
              <Card
                hoverable
                className="text-center h-full flex flex-col items-center justify-center py-8"
                bodyStyle={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
              >
                <div className="bg-blue-100 p-4 rounded-full mb-4">
                  <CloudSun size={40} className="text-blue-600" />
                </div>
                <Title level={4}>{t('weather_station')}</Title>
                <Text className="text-gray-500">
                  {t('weather_desc')}
                </Text>
              </Card>
            </Link>
          </Col>

          <Col xs={24} sm={12}>
            <Link to="/dashboard/dhartinetra">
              <Card
                hoverable
                className="text-center h-full flex flex-col items-center justify-center py-8"
                bodyStyle={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
              >
                <div className="bg-green-100 p-4 rounded-full mb-4">
                  <Leaf size={40} className="text-green-600" />
                </div>
                <Title level={4}>{t('dhartinetra')}</Title>
                <Text className="text-gray-500">
                  {t('dhartinetra_desc')}
                </Text>
              </Card>
            </Link>
          </Col>
        </Row>

        <div
          className="mt-8 p-4 rounded-lg border-l-4 border-amber-400 dark:border-amber-500 border"
          style={{ background: 'var(--color-surface)', borderColor: 'var(--color-border)' }}
        >
          <Text style={{ color: 'var(--color-text-secondary)' }}>
            <strong style={{ color: 'var(--color-text)' }}>{t('note')}:</strong> {t('whatsapp_note')}
          </Text>
        </div>
      </motion.div>
    </SimpleDashboardLayout>
  );
};

export default SimpleDashboard;
